import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import "chart.js/auto";

import { createStore } from "redux";
import { Provider } from "react-redux";
import allReducers from "./flux/reducers/index";

const Admin = lazy(() => import("./layouts/Admin.js"));
const SignInSide = lazy(() => import("./siginIn/SignInSide"));
const Cadastro = lazy(() => import("./siginIn/Cadastro"));
const ValidaCadastro = lazy(() => import("ViewsDinamicAux/ValidaCadastro/ValidaCadastro.js"));
const Recovery = lazy(() => import("siginIn/recovery.js"));

const store = createStore(allReducers);
const hist = createBrowserHistory();

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Router history={hist}>
      <Suspense fallback={<div />}>
        <Switch>
          <Route path="/" exact component={SignInSide} />
          <Route path="/ValidaCadastro/:token" component={ValidaCadastro} />
          <Route path="/recovery/:uuid" exact component={Recovery} />
          <Route path="/cadastro" exact component={Cadastro} />
          <Route path="/pages" component={Admin} />
          <Redirect from="/admin/:subpath" to="/pages/:subpath" />
          <Redirect from="/RetornaFormulas" to="/pages/RetornaFormulas" />
          <Redirect from="/Formulador" to="/pages/Noticias" />
          <Redirect from="/ImportacoesMundo" to="/pages/Noticias" />
          <Redirect from="/PowerBiImportacoes" to="/pages/PowerBiImportacoes" />
          <Redirect from="/PrecificaPorto" to="/pages/PrecificaPorto" />
          <Redirect from="/AndamentoMercadoBrasil" to="/pages/AndamentoMercadoBrasil" />
          <Redirect from="/CadastroADM" to="/pages/CadastroADM" />
          <Redirect from="/ConfigGrupos" to="/pages/ConfigGrupos" />
          <Redirect from="/GestaoUsuarios" to="/pages/GestaoUsuarios" />
          <Redirect from="/ConfigFazendas" to="/pages/Noticias" />
          <Redirect from="/PerfilUsuario" to="/pages/PerfilUsuario" />
          <Redirect from="/ListaDePrecos" to="/pages/Noticias" />
          <Redirect from="/HistoricoUsabilidade" to="/pages/HistoricoUsabilidade" />
          <Redirect from="/HistoricoFretes" to="/pages/Noticias" />
          <Redirect from="/HistRelacaoDeTroca" to="/pages/Noticias" />
          <Redirect from="/PrevisaoClimatica" to="/pages/PrevisaoClimatica" />
          <Redirect from="/ConfigPortos" to="/pages/ConfigPortos" />
          <Redirect from="/AssociacaoProdutosPadrao" to="/pages/Noticias" />
          <Redirect from="/ProdutosPadraoAssociados" to="/pages/Noticias" />
          <Redirect from="/GerenciarPosts" to="/pages/GerenciarPosts" />
          <Redirect from="/CriarPost" to="/pages/CriarPost" />
          <Redirect from="/Noticias" to="/pages/Noticias" />
          <Redirect from="/News" to="/pages/Noticias" />
          <Redirect from="/Dashboard" to="/pages/Dashboard" />
        </Switch>
      </Suspense>
    </Router>
  </Provider>
);
